import PropTypes from 'prop-types'
import { always, cond, F, T } from 'ramda'
import { makeHasRights } from 'selectors/authorization'
import { useMakeSelector } from 'hooks/redux'
import { isFunction, isArray, isString } from 'utils/types'

const HasRights = ({ rights, children, render, modifiers }) => {
  const requestedRights = cond([
    [always(isArray(rights)), always(rights)],
    [always(isString(rights)), always([rights])],
    [T, always([])],
  ])()

  const hasRights = useMakeSelector(makeHasRights, { rights: requestedRights })
  const modified = isFunction(modifiers) ? modifiers() : modifiers

  // truethly/falsey will be ignored
  const canAccess = hasRights === false || modified === false ? F() : T()

  if (isFunction(render)) return render(canAccess)

  if (canAccess) return children

  return null
}

HasRights.propTypes = {
  rights: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  children: PropTypes.element,
  render: PropTypes.func,
  // if modifiers is a function, should always return a bool
  modifiers: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
}

export default HasRights
